import { ca } from '@cian/analytics';

export const trackServiceClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'mobile_main_page',
    action: 'click_services',
    label,
  });
};
